module.exports = __webpack_public_path__ + "static/media/firefox-logo-300x310.ca44b2d4.png";